(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-zebro"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function showToast(msg) {
    var t = document.createElement('div');
    t.className = 'pcz-toast';
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () {
      t.classList.add('pcz-toast--on');
      setTimeout(function () {
        t.classList.remove('pcz-toast--on');
        setTimeout(function () { t.remove(); }, 400);
      }, 2400);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pcz__atc');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var vid  = btn.dataset.variantId;
    if (!vid) return;

    var orig = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Ajouté !';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      showToast('Produit ajouté au panier');
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = 'Erreur';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    });
  }, true);

}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-zebro"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  document.querySelectorAll('[data-pgz]').forEach(function (root) {
    var sid      = root.dataset.pgz;
    var track    = document.getElementById('pgz-track-' + sid);
    var dotsWrap = document.getElementById('pgz-dots-' + sid);
    var mainImg  = document.getElementById('pgz-main-img-' + sid);
    var mainVid  = document.getElementById('pgz-main-video-' + sid);
    var thumbs   = root.querySelectorAll('.pgz__thumb');

    /* ── Desktop : clic thumbnail → mise à jour image principale ── */
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('pgz__thumb--on'); });
        btn.classList.add('pgz__thumb--on');

        if (btn.dataset.pgzType === 'video' && mainVid && mainImg) {
          mainImg.style.display = 'none';
          mainVid.classList.remove('pgz__main-video--hidden');
          mainVid.play().catch(function () {});
        } else {
          if (mainVid) {
            mainVid.classList.add('pgz__main-video--hidden');
            mainVid.pause();
          }
          if (mainImg) {
            mainImg.style.display = '';
            mainImg.src = btn.dataset.pgzSrc;
            mainImg.alt = btn.dataset.pgzAlt || '';
          }
        }
      });
    });

    /* ── Flèches mobile ── */
    var btnPrev = document.getElementById('pgz-prev-' + sid);
    var btnNext = document.getElementById('pgz-next-' + sid);
    if (btnPrev && btnNext && track) {
      function pgzScrollTo(idx) {
        track.scrollTo({ left: idx * track.offsetWidth, behavior: 'smooth' });
      }
      function pgzCurrentIdx() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }
      var pgzTotal = track.querySelectorAll('.pgz__slide').length;
      btnPrev.addEventListener('click', function () {
        var i = pgzCurrentIdx();
        pgzScrollTo(i > 0 ? i - 1 : pgzTotal - 1);
      });
      btnNext.addEventListener('click', function () {
        var i = pgzCurrentIdx();
        pgzScrollTo(i < pgzTotal - 1 ? i + 1 : 0);
      });
    }

    /* ── Mobile : scroll → mise à jour dots et thumbnails ── */
    if (track && dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.pgz__dot');
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.offsetWidth);
        dots.forEach(function (d, i) { d.classList.toggle('pgz__dot--on', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('pgz__thumb--on', i === idx); });
      }, { passive: true });
    }

    /* ── Video mobile : autoplay via IntersectionObserver ── */
    var mobileVids = root.querySelectorAll('.pgz__media--video');
    if (mobileVids.length && 'IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.play().catch(function () {}); }
          else { en.target.pause(); }
        });
      }, { threshold: 0.4 });
      mobileVids.forEach(function (v) { vo.observe(v); });
    }
  });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-cta"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  document.querySelectorAll('[data-sticky]').forEach(function (bar) {
    var sid      = bar.dataset.sticky;
    var sentinel = document.getElementById('psticky-sentinel-' + sid);
    var mainBtn  = document.getElementById('cph-btn-add-' + sid);

    if (!sentinel) return;

    /* Déplacer la sentinelle avant le footer */
    var footer = document.querySelector('footer, .shopify-section:last-child');
    if (footer) footer.insertAdjacentElement('beforebegin', sentinel);

    function showBar() { bar.classList.add('psticky--on'); bar.removeAttribute('aria-hidden'); }
    function hideBar() { bar.classList.remove('psticky--on'); bar.setAttribute('aria-hidden', 'true'); }

    if ('IntersectionObserver' in window) {
      /* Cacher quand footer visible */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { hideBar(); } else { showBar(); }
        });
      }, { threshold: 0 }).observe(sentinel);

      /* Cacher aussi quand le bouton principal est above fold */
      if (mainBtn) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { hideBar(); } else { showBar(); }
          });
        }, { threshold: 0.5 }).observe(mainBtn);
      }
    } else {
      showBar();
    }
  });
}());
  } catch(e) { console.error(e); }
})();

})();
